import { ViteReactSSG } from "vite-react-ssg";
import { routes } from "./routes";
import "./index.css";

export const createRoot = ViteReactSSG(
  { routes },
  ({ isClient }) => {
    // SSG callback - runs on both client and server
  },
  {
    // Client options - use HelmetProvider for meta tag handling
    rootContainer: "#root",
  }
);
